
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import AffiliatedJobsPreviewJobDialog from '@/components/dialogs/AffiliatedJobsPreviewJobDialog.vue';

@Component({
  components: {
    AffiliatedJobsPreviewJobDialog,
  },
})
export default class AffiliatedJobsDialogLink extends Vue {
  @Prop(Number) public jobId: number;

  public previewJobId = NaN;
  public isShow = false;

  public handleJobClick(jobId) {
    this.previewJobId = jobId;
    this.isShow = true;
  }

  public handleDialogClose() {
    this.isShow = false;
  }
}
